<template>
  <v-app
    id="appystudio"
    light class="appy-color gray-4">
    <v-content class="p-appy-appystudio-topbar-layout" fill-height>
      <v-container fluid text-xs-center fill-height class="pa-0 ma-0" >
        <v-layout column class="pa-0 ma-0">
          <v-flex align-left shrink text-xs-left dark class="p-appy-layout-top-bar">
            <v-layout row wrap fill-height>
              <v-flex d-flex align-left shrink>
                <v-card flat color="transparent" dark class="pa-2 px-4 p-appy-logo" to="/editor/appystudio/welcome/select" nuxt>
                  <v-card-actions class="font-raleway appy-header appy-sm">APPY STUDIO<span v-if="isBeta()" class="font-raleway appy-label-1 pl-2">beta</span></v-card-actions>
                </v-card>
                <v-spacer></v-spacer>
              </v-flex>
              <v-flex d-flex align-center grow>

              </v-flex>
              <v-flex d-flex shrink>
                <v-spacer></v-spacer>
                <v-btn v-if="showMailingsButton()" nuxt flat dark color="white" to="/editor/appystudio/?shortcut=layouts-sent" class="font-raleway appy-header appy-xs"><v-icon class="pr-2" color="appy-color gold">send</v-icon> SENT MAILINGS</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex fill-height class="p-appy-layout-content pa-0 ma-0">
            <nuxt/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import "~/assets/scss/v_themes/appystudiotopbar.scss";
  import { event } from '~/src/util/eventBus'

  export default {
    name: "Appystudiotopbar",
    layoutTransition: {
      name: 'layout',
      mode: 'out-in'
    },
    provide () {
      this.eventBus = event.init()
      return {
        'eventBus': this.eventBus
      }
    },
    props: {},
    methods: {
      isBeta() {
        return false
      },
      showMailingsButton() {
        return this.$route.path !== '/digitalinvites/' && this.$route.path !== '/digitalinvites'
      }
    },
    data() {
      return {}
    }
  }
</script>

<style lang="sass">
  @import "~assets/scss/v_themes/common/modules/fonts/raleway";
  @import "~assets/scss/v_themes/common/modules/fonts/open_sans";
  @import "~assets/scss/v_themes/appystudiotopbar.scss";
</style>
